import 'Styles/forumview.scss';

import React from 'react';
import { connect } from 'react-redux';

import forumViewSelector from 'Selectors/forumViewSelector';
import { fetchForum } from 'Actions/ForumviewActions';
import { checkAdsPermissions, resetHiddenAdsPerUser, onPageView, trackPageView } from 'Actions/adsActions';
import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { resetForum } from 'Actions/ForumviewActions';
import { resetThread } from 'Actions/ThreadviewActions';
import { closeAnnouncements } from 'Actions/UiActions';

import Breadcrumb from 'Components/common/BreadcrumbComponent';
import ThreadList from 'Components/threads/ThreadListComponent';
import AnnouncementsView from 'Components/forums/AnnouncementsViewComponent';
import ForumList from 'Components/forums/ForumListComponent';
import AdComponent from 'Components/ads/AdComponent';
import InfiniteScroll from 'Components/infiniteScroll/InfiniteScrollComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

class ForumViewComponent extends React.Component {
	componentDidMount() {
		this.props.dispatch(resetInfinite());
		this.props.dispatch( resetForum() );
		this.props.dispatch( resetThread() );
		this.props.dispatch( closeAnnouncements() );

		let page = this.props.location.query.page || 1;
		this.props.dispatch(fetchForum({
			id: this.props.routeParams.forumId,
			page: parseInt( page )
		}));
	}

	componentWillUnmount() {
		this.props.dispatch( resetForum() );
		this.props.dispatch( resetThread() );
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( closeAnnouncements() );

	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.forumview.loaded !== this.props.forumview.loaded
			|| nextProps.forumview.isFetching !== this.props.forumview.isFetching
			|| nextProps.forumview.result.topics.length !== this.props.forumview.result.topics.length
			|| nextProps.forumview.forumId !== this.props.forumview.forumId
		);
	}

	componentWillReceiveProps(nextProps) {
		if( this.props.routeParams.forumId !== nextProps.routeParams.forumId ) {
			window.scrollTo( 0, 0 );

			this.props.dispatch( fetchForum( {
				id: nextProps.routeParams.forumId,
				page: 1,
				forceRefresh: true
			} ) );
			return;
		}
		if( nextProps.forumview.forumId !== this.props.forumview.forumId ) {
			this.props.dispatch( closeAnnouncements() );
			this.props.dispatch( checkAdsPermissions( parseInt( nextProps.forumview.forumId ) ) );
			this.props.dispatch( resetHiddenAdsPerUser() );
		}
		if( nextProps.forumview.loaded && nextProps.forumview.loaded !== this.props.forumview.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView( { captify: "" } ) );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	loadPage = ( page, forceRefresh ) => {
		this.props.dispatch(fetchForum({
			id: this.props.routeParams.forumId,
			page: page,
			forceRefresh: forceRefresh
		}));
	};

	render() {
		const { loaded, isFetching } = this.props.forumview;

		if( !loaded ) {
			return <LoaderCss />;
		}

		let adUnit = <AdComponent adType="5" fallbackAdType={ [1] } adName="In_Content_Ad" />,
			campaignAd = <AdComponent adType="505" adName="Campaign_Top_Ad" />,
			bottomAdUnit = <AdComponent adType="2" adName="Bottom_Content_Rectangle" isFetching={ isFetching } />;

		return (
			<div>
				<Breadcrumb routeParams={this.props.routeParams} />
				<AnnouncementsView />
				<ForumList />
				{ adUnit }
				{ campaignAd }
				<InfiniteScroll
					scrollRef={ i => this.infiniteScroll = i }
					isFetching={isFetching}
					loadPage={this.loadPage}
					location={this.props.location}>
						<ThreadList />
				</InfiniteScroll>
				{bottomAdUnit}
			</div>
		);
	}
}

export default connect( forumViewSelector )( ForumViewComponent );


// WEBPACK FOOTER //
// ./src/components/ForumViewComponent.js